import {  Loading } from "components"
import { Fragment } from "react"
import { useProductLog } from "./hooks/useProductLog"

export function TabProductLog(props: { id:number }) {

  const { dataProductLog, isLoading } = useProductLog(Number(props.id))
  
  return (
    <Fragment>
      {isLoading || dataProductLog?.length === 0 ? (    
          <Loading
            loading={isLoading}
            errorText="No data available"
          />
               
          ) : (
            <div className="">
              <ul className="list">
                { dataProductLog?.map((row) => (
                    <li key={row.log_id} className="list-row border-b-2 py-2">{row.description}</li>
                ))}
              </ul>
            </div>
          )
        }
    </Fragment>
  )
}